"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agordo": {
    "afd4e5c4": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "brugnach": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52ff0ea7": [{
      "hkey": "8032a365",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "colvignas": [{
      "hkey": "8032a365",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agordo"
    }],
    "9c059954": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "crostolin": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eefa2070": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "le-grave": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15cfc5b6": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "mozzach": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d788be57": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "pa-rech": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64817a12": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-alto": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cd777c4": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "toccol": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1704ca4": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "val-di-frela": [{
      "hkey": "ae46f7a4",
      "slug": "agordo",
      "name": "Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6c74f31": [{
      "hkey": "8032a365",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "veran": [{
      "hkey": "8032a365",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agordo"
    }]
  }
};
exports["default"] = _default;